import { isTouchDevice } from "@myvp/shared/src/functions/is-touch-device"
import { isSafari } from "@myvp/shared/src/functions/is-safari"

export function isAndroid(userAgent: string = navigator.userAgent) {
  // https://stackoverflow.com/a/6031480/4663874
  // It's worth noting that this does not always work for android devices as, for example, the user agents which are reported by Kindle Fire HD devices do not contain the word 'android' at all.
  return /Android/i.test(userAgent) && isTouchDevice() && !isSafari()
}
